import { Sized } from '@optimus-web/common';
import { ActivableRendererProps, ClickAwayProps } from '@optimus-web/helpers';
import { ButtonProps } from '../Button';

export enum DialogPosition {
    Aside = 'aside',
    Center = 'center',
    Corner = 'corner',
}

export interface DialogBaseProps extends ActivableRendererProps, Sized {
    active?: boolean;
    modal?: boolean;
    position?: DialogPosition;
    contentWithoutPadding?: boolean;
    actions?: Array<ButtonProps & { key?: string }>;
    footerDetail?: React.ReactNode;
    portalContainerId?: string;
    children: React.ReactNode;
    onClose?: (e: React.MouseEvent) => void;
    title?: React.ReactNode;
    innerRef?: (c: HTMLElement | null) => void;
    inline?: boolean;
    anchorElement?: HTMLElement | null;
    /**
     * @deprecated
     */
    noMaxWidth?: boolean;
    mobileFullscreen?: boolean;
    loading?: boolean;
}

export type DialogProps = DialogBaseProps & ClickAwayProps;
